/**
 * @fileoverview Runtime side-effect: define `console.errorNormalized` when absent.
 *
 * @purpose Node/tsx ESM loads `@korvo/core` TypeScript sources without a bundler; this module must
 *          exist as a `.ts` sibling of `normalize-error.ts` so `import './console-error-normalized-polyfill'`
 *          resolves during `runModuleSeeds` and similar bootstrap paths.
 * @usage Imported only for side effects from `normalize-error.ts` and `console-error-normalized.ts`.
 * @ownership @korvo/core error helpers
 * @dependencies none (runs before any other Korvo console helpers)
 * @restrictions Callers import **`./console-error-normalized-polyfill.js`**: Node/tsx hits this
 *   sibling **`.js`** bridge, which re-imports this **`.ts`** file; Next/webpack resolves the same **`.js`** path.
 *
 * @docs docs/fixes/2026-04-16-normalize-error-esm-runtime-import.md
 */

type ConsoleWithNormalized = typeof console & {
  errorNormalized?: (message?: unknown, ...optionalParams: unknown[]) => void;
};

const c = console as ConsoleWithNormalized;
if (typeof c.errorNormalized !== 'function') {
  c.errorNormalized = (message?: unknown, ...optionalParams: unknown[]) => {
    console.error(message, ...optionalParams);
  };
}

export {};
